"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.function.name");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ItemElement = _interopRequireDefault(require("../ItemElement"));

var _HeaderIcon = _interopRequireDefault(require("./components/HeaderIcon"));

var Review =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2["default"])(Review, _React$PureComponent);

  function Review() {
    (0, _classCallCheck2["default"])(this, Review);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Review).apply(this, arguments));
  }

  (0, _createClass2["default"])(Review, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as,
          name = _this$props.name,
          company = _this$props.company,
          content = _this$props.content,
          charLimit = _this$props.charLimit,
          image = _this$props.image,
          cardInlinePhoto = _this$props.cardInlinePhoto,
          imageCircular = _this$props.imageCircular,
          imageSize = _this$props.imageSize,
          itemButtonFloat = _this$props.itemButtonFloat,
          itemCenterContent = _this$props.itemCenterContent,
          link = _this$props.link,
          linkAs = _this$props.linkAs,
          linkContent = _this$props.linkContent,
          verticalItemAlign = _this$props.verticalItemAlign;
      return _react["default"].createElement(_ItemElement["default"], {
        as: as,
        header: name,
        headerIcon: link ? _react["default"].createElement(_HeaderIcon["default"], {
          link: link,
          showLink: linkAs !== 'header',
          isVerticalItem: as === 'verticalItem'
        }) : null,
        subheader: company,
        content: content,
        charLimit: charLimit,
        image: image,
        cardInlinePhoto: cardInlinePhoto,
        imageCircular: imageCircular,
        imageSize: imageSize,
        itemButtonFloat: itemButtonFloat,
        itemCenterContent: itemCenterContent,
        link: link,
        linkAs: linkAs,
        linkContent: linkContent,
        verticalItemAlign: verticalItemAlign
      });
    }
  }]);
  return Review;
}(_react["default"].PureComponent);

exports["default"] = Review;
Review.propTypes = {
  content: _propTypes["default"].string.isRequired,
  as: _propTypes["default"].oneOf(['verticalItem', 'horizontalItem', 'card']),
  cardInlinePhoto: _propTypes["default"].oneOf(['left', false]),
  charLimit: _propTypes["default"].number,
  company: _propTypes["default"].string,
  image: _propTypes["default"].string,
  imageCircular: _propTypes["default"].bool,
  imageSize: _propTypes["default"].string,
  itemButtonFloat: _propTypes["default"].oneOf(['left', 'right']),
  itemCenterContent: _propTypes["default"].bool,
  link: _propTypes["default"].string,
  linkAs: _propTypes["default"].oneOf(['button', 'header', 'none']),
  linkContent: _propTypes["default"].string,
  name: _propTypes["default"].string,
  verticalItemAlign: _propTypes["default"].oneOf(['left', 'right', 'center'])
};
Review.defaultProps = {
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 280,
  company: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  linkContent: '',
  name: '',
  verticalItemAlign: 'center'
};